// Login form.
import React from 'react';
import { FormattedMessage } from 'react-intl';

import CheckBox from '../widgets/checkbox.jsx';
import VisiblePassword from '../widgets/visible-password.jsx';




export default class LoginView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      login: props.login,
      password: '',
      hostName: props.serverAddress,
      saveToken: props.persist
    };
    this.handleLoginChange = this.handleLoginChange.bind(this);
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
    this.handleToggleSaveToken = this.handleToggleSaveToken.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleGoogleLogin = this.handleGoogleLogin.bind(this);
  }

  handleLoginChange(e) {
    this.setState({login: e.target.value});
  }

  handlePasswordChange(e) {
    this.setState({password: e.target.value});
  }

  handleToggleSaveToken() {
    this.props.onPersistenceChange(!this.state.saveToken);
    this.setState({saveToken: !this.state.saveToken});
  }

  handleSubmit(e) {
    e.preventDefault();
    this.props.onLogin(this.state.login.trim(), this.state.password.trim());
  }

  handleGoogleLogin(e) {
    e.preventDefault();
    // Здесь вызовите метод входа через Google
    this.props.onLogin(this.state.login.trim(), this.state.password.trim(),true);
  }

  render() {
    let submitClasses = 'primary';
    if (this.props.disabled) {
      submitClasses += ' disabled';
    }

    return (
      <form id="login-form" onSubmit={this.handleSubmit}>
        <div className="login-hello">
          <FormattedMessage id="login_prompt_hello" defaultMessage="To start solving a problem with your partner or virtual psychologist, you should log in to the messenger"
            description="To start solving a problem with your partner or virtual psychologist, you should log in to the messenger"/>
        </div>


        <div >
          <FormattedMessage id="login_prompt_input" defaultMessage="Login if you have already registered"
            description="Login if you have already registered"/>
        </div>

        <FormattedMessage id="login_prompt" defaultMessage="Login"
          description="Placeholer for username/login">
        {
          (login_prompt) => <input type="text" id="inputLogin"
            placeholder={login_prompt}
            autoComplete="username"
            autoCorrect="off"
            autoCapitalize="none"
            value={this.state.login}
            onChange={this.handleLoginChange}
            required autoFocus />
        }
        </FormattedMessage>
        <FormattedMessage id="password_prompt" defaultMessage="Password"
          description="Placeholder/prompt for entering password">
        {
          (password_prompt) => <VisiblePassword type="password" id="inputPassword"
            placeholder={password_prompt}
            autoComplete="current-password"
            value={this.state.password}
            onChange={this.handlePasswordChange}
            required={true} />
        }
        </FormattedMessage>
        <div className="panel-form-row">
          <CheckBox id="save-token" name="save-token" checked={this.state.saveToken}
            onChange={this.handleToggleSaveToken} />
          <label htmlFor="save-token">&nbsp;
            <FormattedMessage id="stay_logged_in" defaultMessage="Stay logged in"
              description="Label for a checkbox" />
          </label>
          <a href="#reset">
            <FormattedMessage id="forgot_password_link" defaultMessage="Forgot password?"
              description="Link to Reset password form" />
          </a>
        </div>
        <div className="dialog-buttons">
          <button className={submitClasses} type="submit">
            <FormattedMessage id="button_sign_in" defaultMessage="Sign in"
              description="Button [Sign In]" />
          </button>
          
        </div>

         {/* Разделительная линия 
         <div className="divider">
          <hr />
        </div> */}

        <div className="divider-with-text">
          <div className="divider-line" />
            <span className="divider-text"> <FormattedMessage id="or" defaultMessage="OR"
              description="OR" /> </span>
          <div className="divider-line" />
        </div>


        <div class="google-sign-in-container">
        <button className="google-sign-in" onClick={this.handleGoogleLogin}>
          <img src="/img/google.png" alt="Google" />
          <FormattedMessage id="button_sign_in_google" defaultMessage="Sign in with Google"
            description="Button [Sign in with Google]" />
        </button>
        </div>


        <div className="divider-with-text">
          <div className="divider-line" />
            <span className="divider-text"> <FormattedMessage id="or" defaultMessage="OR"
              description="OR" /> </span>
          <div className="divider-line" />
        </div>
        <div class="google-sign-in-container">
        <button className="secondary" onClick={() => this.props.onSignUp()}> <i className="material-icons">person_add</i>         
        &nbsp;<FormattedMessage id="button_sign_up" defaultMessage="Create account"
            description="Button [Create account]" />
        </button>
        </div>


       

      </form>
    );
  }
};
